const DEFAULT_CATEGORY_INFO = Object.freeze({
  personal: {
    label: 'Persönliche Daten',
    icon: 'user'
  },
  receipt: {
    label: 'Quittungsdaten',
    icon: 'file-invoice'
  },
  financial: {
    label: 'Finanzielle Daten',
    icon: 'euro-sign'
  }
})

const CATEGORY_FIELD_KEYS = {
  personal: {
    label: 'personalCategoryName',
    icon: 'personalCategoryIcon'
  },
  receipt: {
    label: 'receiptCategoryName',
    icon: 'receiptCategoryIcon'
  },
  financial: {
    label: 'financialCategoryName',
    icon: 'financialCategoryIcon'
  }
}

const cloneDefaultInfo = () => ({
  personal: { ...DEFAULT_CATEGORY_INFO.personal },
  receipt: { ...DEFAULT_CATEGORY_INFO.receipt },
  financial: { ...DEFAULT_CATEGORY_INFO.financial }
})

const isCategoryInfoObject = (value) =>
  value &&
  typeof value === 'object' &&
  ['personal', 'receipt', 'financial'].some(
    (key) => value[key] && typeof value[key] === 'object'
  )

const applyCategoryData = (target, source) => {
  if (!source) return

  Object.keys(target).forEach((category) => {
    if (source[category]) {
      if (source[category].label) {
        target[category].label = source[category].label
      }
      if (source[category].icon) {
        target[category].icon = source[category].icon
      }
    }
  })
}

const applyTemplateOverrides = (target, templateLike) => {
  if (!templateLike || typeof templateLike !== 'object') return

  Object.entries(CATEGORY_FIELD_KEYS).forEach(([category, keys]) => {
    if (
      templateLike[keys.label] &&
      typeof templateLike[keys.label] === 'string' &&
      templateLike[keys.label].trim() !== ''
    ) {
      target[category].label = templateLike[keys.label]
    }
    if (
      templateLike[keys.icon] &&
      typeof templateLike[keys.icon] === 'string' &&
      templateLike[keys.icon].trim() !== ''
    ) {
      target[category].icon = templateLike[keys.icon]
    }
  })
}

export const buildCategoryInfo = (source) => {
  const result = cloneDefaultInfo()

  if (!source) {
    return result
  }

  if (isCategoryInfoObject(source)) {
    applyCategoryData(result, source)
  }

  if (source.categoryInfo && isCategoryInfoObject(source.categoryInfo)) {
    applyCategoryData(result, source.categoryInfo)
  }

  if (source.template) {
    applyTemplateOverrides(result, source.template)
  }

  applyTemplateOverrides(result, source)

  return result
}

export const getCategoryLabel = (category, source) => {
  const info = buildCategoryInfo(source)
  return info[category]?.label || category
}

export const getCategoryIcon = (category, source) => {
  const info = buildCategoryInfo(source)
  return info[category]?.icon || 'question'
}

export const DEFAULT_CATEGORIES = DEFAULT_CATEGORY_INFO
